// apolo/src/components/plugins/ToolsCatalogTab.jsx — harness-library-uplift E3-WS1-T04.
//
// Catálogo das ferramentas do harness — a superfície que não existia (achado P1
// da auditoria 12/07: "as ~25 tools são invisíveis até o agente usá-las").
// Fonte única: lib/toolCatalog.js (mesma do feed) — nome, grupo, mutating, descrição.

import { useMemo } from 'react';
import { PencilRuler } from 'lucide-react';
import { listToolCatalog, TOOL_GROUP_LABELS } from '../../lib/toolCatalog.js';

const GROUP_ORDER = ['base', 'seam', 'subagent', 'hermes'];

export default function ToolsCatalogTab({ search = '' }) {
  const groups = useMemo(() => {
    const q = search.trim().toLowerCase();
    const all = listToolCatalog().filter((t) =>
      !q || `${t.name} ${t.verb} ${t.desc}`.toLowerCase().includes(q));
    return GROUP_ORDER
      .map((g) => ({ group: g, label: TOOL_GROUP_LABELS[g], tools: all.filter((t) => t.group === g) }))
      .filter((g) => g.tools.length > 0);
  }, [search]);

  if (groups.length === 0) {
    return <p className="px-4 py-8 text-center text-xs text-apolo-textTertiary">Nenhuma ferramenta bate com essa busca.</p>;
  }

  return (
    <div className="space-y-5 px-4 py-3" data-testid="tools-catalog">
      {groups.map(({ group, label, tools }) => (
        <section key={group}>
          <h3 className="mb-2 text-[10px] font-medium uppercase tracking-wider text-apolo-textTertiary">
            {label} · {tools.length}
          </h3>
          <ul className="space-y-1.5">
            {tools.map((t) => {
              const Icon = t.icon || PencilRuler;
              return (
                <li key={t.name} className="flex items-start gap-2 rounded-md border border-apolo-borderSubtle bg-apolo-surface2 px-3 py-2">
                  <Icon size={14} aria-hidden="true" className="mt-0.5 shrink-0 text-apolo-textSecondary" />
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-baseline gap-x-2">
                      <code className="text-[12px] font-medium text-apolo-textPrimary">{t.name}</code>
                      <span className="text-[10px] text-apolo-textTertiary">{t.verb}</span>
                      {t.mutating && (
                        <span
                          className="rounded-full border border-apolo-warning/40 px-1.5 text-[9px] uppercase tracking-wide text-apolo-warning"
                          title="Ferramenta mutante — escreve/executa; respeita plan-mode e aprovação"
                        >
                          muta
                        </span>
                      )}
                    </div>
                    <p className="text-[11px] leading-snug text-apolo-textSecondary">{t.desc}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        </section>
      ))}
    </div>
  );
}
